// ui
import { Icon, IconProps } from "@chakra-ui/react";

export const PlayFillIcon = (props: IconProps) => (
  <Icon viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M21.3273 15.967L31.7905 22.7094C32.7092 23.3132 32.7092 24.6214 31.7905 25.2252L21.3273 31.9675C20.3065 32.6216 18.9795 31.9172 18.9795 30.7096V17.2249C18.9795 16.0173 20.3065 15.3129 21.3273 15.967Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M20.9488 16.5563C20.3776 16.191 19.6793 16.5907 19.6793 17.2253V30.71C19.6793 31.3446 20.3777 31.7443 20.9489 31.3788C20.9491 31.3787 20.9488 31.3789 20.9489 31.3788L31.4081 24.6391C31.903 24.3117 31.903 23.6236 31.4081 23.2962L20.9488 16.5563C20.9486 16.5562 20.949 16.5565 20.9488 16.5563ZM18.2793 17.2253C18.2793 15.4449 20.2345 14.4359 21.7048 15.378L21.7063 15.379L32.1747 22.1247C33.5142 23.005 33.5142 24.9302 32.1747 25.8105L32.1694 25.814L21.7063 32.5563L21.7048 32.5572C20.2345 33.4994 18.2793 32.4903 18.2793 30.71V17.2253Z"
      fill="currentColor"
    />
  </Icon>
);
